import "../../../assets/presentation/components/example-dialog/example-dialog-QTz3fPQH.css";
/* empty css               */
import { Button, ButtonLabel, ButtonPriority, CloseModalButton, Dialog, DialogContent, DialogHeader, registerModalView } from "@vana/core";
import { useTranslation } from "react-i18next";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/presentation/components/example-dialog/example-dialog.tsx
var EXAMPLE_DIALOG_KEY = "HomeExampleDialogKey";
var ExampleDialog = ({ className, hide }) => {
	const { t } = useTranslation("home");
	return /* @__PURE__ */ jsx(Dialog, {
		className,
		children: /* @__PURE__ */ jsxs(DialogContent, {
			className: "home-example-dialog",
			children: [
				/* @__PURE__ */ jsx(DialogHeader, { children: /* @__PURE__ */ jsx(CloseModalButton, { onClick: hide }) }),
				/* @__PURE__ */ jsx("h1", { children: t("example_dialog_title") }),
				/* @__PURE__ */ jsx("p", { children: t("example_dialog_description") }),
				/* @__PURE__ */ jsx(Button, {
					priority: ButtonPriority.PRIMARY,
					onClick: hide,
					fullHeight: true,
					maxRounded: true,
					children: /* @__PURE__ */ jsx(ButtonLabel, { children: t("example_dialog_close_action") })
				})
			]
		})
	});
};
registerModalView(EXAMPLE_DIALOG_KEY, (props) => /* @__PURE__ */ jsx(ExampleDialog, {
	className: props.className,
	hide: props.hide
}));
//#endregion
export { EXAMPLE_DIALOG_KEY, ExampleDialog };

//# sourceMappingURL=example-dialog2.js.map